<header [ngClass]="showHeader ? 'sticky top-0 z-10' : ''" class="bg-white shadow-sm">
  <nav class="container lg:px-0 flex  justify-between items-center w-full md:flex-row pt-5 pb-3 md:pt-7 md:pb-5">
    <div class="items-center lg:hidden flex">
      <button matRipple color="primary" (click)="toggleSideNav()" aria-label="Drawer Toggle Button"
        class="flex items-center justify-center rounded-full h-9 w-9 lg:hidden">
        <img src="assets/images/menu.svg" height="40px" width="40px" alt="humberger menu icon"
          class="lg:hidden block" />
      </button>
    </div>
    <ul class="w-full md:w-auto  flex flex-row-reverse md:flex-row flex-3 justify-between items-center gap-2 md:gap-4">
      <!-- right section codes -->

      <li class="md:hidden phone ml-2 md:ml-0" *ngIf="!userDataTopNav">
        <button matRipple (click)="openDialog()" id="btn-login"
          class="flex items-center py-1 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm">
          <i class="ico-Profile text-xl"></i>
          <span class="text-sm !font-semi-bold whitespace-nowrap">ورود | ثبت نام</span>
        </button>
      </li>
      <li>
        <div class="flex w-full justify-end items-center pr-3 md:pr-0">
          <a (click)="resetRayaChat($event)" href="/" aria-label="">
                <img [ngSrc]="cdnUrl + '/images/logo-new.webp'" priority role="logo"
                  alt="ایران هتل آنلاین | رزرو هتل، هتل آپارتمان، اقامتگاه‌های بوم گردی، اقامت بلند مدت" height="36" width="100"
                  class="ml-4 w-[100px] h-[36px] object-contain" />
          </a>
          <img *ngIf="utmService.utmImageSource()" [src]="utmService.utmImageSource()" class="h-[35px]" />
        </div>
      </li>
      <li class="hidden lg:list-item" [matMenuTriggerFor]="hotels" #hotelMenuTrigger="matMenuTrigger">
        <button (mouseenter)="openHotelMenu()" #reserveHotel matRipple id="btn-reserveHotel"
          class="flex items-center text-sm px-3 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm font-bold">
          <a href="https://www.iranhotelonline.com/">
            <span class="!font-semi-bold">
              رزرو هتل</span>
            <ul ngSkipHydration class="hidden-custom">
              <li><a mat-menu-item href="/mashhad-hotels/"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های
                  مشهد</a></li>
              <li><a mat-menu-item href="/tehran-hotels/"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های
                  تهران</a></li>
              <li><a mat-menu-item href="/shiraz-hotels/"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های
                  شیراز</a></li>
              <li><a mat-menu-item href="/isfahan-hotels/"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های
                  اصفهان</a></li>
              <li><a mat-menu-item href="/kish-hotels/"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل
                  های
                  کیش</a></li>
              <li><a mat-menu-item href="/iran-hotels/" target="_blank"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
                  هتل های ایران
                </a></li>
              <li>
                <a mat-menu-item target="_blank" href="/international-hotels/"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
                  هتل‌های خارجی
                </a>
              </li>
            </ul>


          </a>
          <i class="ico-Down text-2xl"></i>
          <a href="/" routerlink="/"></a>
        </button>
      </li>

      <li class="hidden lg:flex" [matMenuTriggerFor]="ecolodgeMenu" #ecolodgeMenuTrigger="matMenuTrigger">
        <button (mouseenter)="openEcolodgeMenu()" #reserveEcolodge matRipple id="btn-reserveEcolodge"
          class="flex items-center text-sm px-3 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm font-bold">
          <a href="/ecolodge/">
            <span class="!font-semi-bold">
              اجاره ویلا</span>
            <ul ngSkipHydration class="hidden-custom">
              <li>
                <a mat-menu-item href="/ecolodge/مشهد/"
                  class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
                  ویلاهای مشهد
                </a>
              </li>
            </ul>
          </a>
          <i class="ico-Down text-2xl"></i>
        </button>
      </li>

      <li class="list-item md:hidden" *ngIf="userDataTopNav">

        <button [matMenuTriggerFor]="loginDropDown"
          class="login-head-item absolute right-[80px] top-[20px] p-3 rounded-full text-sm !font-semi-bold h-8 w-8 bg-blue-500 text-white flex justify-center items-center">
          <span class="text-sm ml-1 !font-semi-bold" *ngIf="userDataTopNav.FirstName">{{
            userDataTopNav.FirstName ? userDataTopNav.FirstName.slice(0, 1) : ''
            }}</span>
          <span class="text-sm !font-semi-bold" *ngIf="userDataTopNav.LastName">{{
            userDataTopNav.LastName ? userDataTopNav.LastName.slice(0, 1) : ''
            }}</span>
          <span class="text-sm !font-semi-bold" *ngIf="!userDataTopNav.FirstName && !userDataTopNav.LastName" class="{{
       !userDataTopNav.FirstName && !userDataTopNav.LastName ? 'ico-Profile text-xl' : ''
      }}"></span>
        </button>

      </li>

  
    </ul>

    <ul class="flex items-center gap-4">
      <li class="hidden lg:flex">
        <a matRipple href="/help/" target="_blank" id="link-help"
          class="flex items-center py-1 px-3 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm">
          <i class="ico-Message text-xl"></i>
          <span class="text-sm !font-semi-bold">مرکز پشتیبانی</span>
        </a>
      </li>

      <li class="hidden lg:flex relative">
        <a href="/persian/userprofile/#/reserve/" id="link-userprofile-reserve" *ngIf="userDataTopNav" matRipple
          class="flex items-center py-1 px-3 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm">
          <i class="ico-Suitcase text-xl"></i>
          <span class="text-sm !font-semi-bold">رزروهای من</span>
        </a>
        <a href="/persian/pursuit/tracking/" id="link-tracking" *ngIf="!userDataTopNav" matRipple
          class="flex items-center py-1 px-3 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm">
          <i class="ico-Suitcase text-xl"></i>
          <span class="text-sm !font-semi-bold">پیگیری رزرو</span>
        </a>
        <!--  create badge red with tailwind   -->
        <div *ngIf="showCardWithData"
          class="absolute inline-flex items-center justify-center w-2 h-2 text-xs font-bold text-white bg-[#FA4549]  rounded-full right-[20px] top-[2px] dark:border-gray-900">
        </div>
        <ng-container *ngIf="showCardWithData && !navigatorVall">
          <iho-last-reserve-card *ngIf="!showCardReserve" (emitClose)="emitClose($event)" [isMobile]="navigatorVall"
            [latestActiveReserve]="latestActiveReserve"></iho-last-reserve-card>
        </ng-container>



      </li>

      <li class="hidden md:block desktop isLoading" *ngIf="(!isLoading && !userDataTopNav)">
        <button matRipple (click)="openDialog()" id="btn-login"
          class="flex items-center py-1 px-3 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm">
          <i class="ico-Profile text-xl"></i>
          <span class="text-sm !font-semi-bold whitespace-nowrap">ورود | ثبت نام</span>
        </button>

      </li>

      <li class="hidden md:block desktop" *ngIf="isLoading">
        <div class="skeleton skeleton__text" [style.width]="'100px'" [style.height]="'30px'"></div>
      </li>
      <li class="hidden md:block desktop isLoading">
        <!-- just for desktop (showing user name) -->

        <button matRipple *ngIf="(!isLoading && userDataTopNav)" name="login-register-button"
          [matMenuTriggerFor]="loginDropDown" (click)="!userDataTopNav ? openDialog() : null"
          class="flex items-center py-1 px-3 gap-1 rounded-md transition-all hover:bg-metal-50 text-black-500 hover:shadow-sm">
          <i class="ico-Profile text-xl"></i>
          <span class="text-sm">{{
            userDataTopNav?.RegisterType === '3' ? (userDataTopNav?.NickName ?? userDataTopNav?.ParentName ??
            userDataTopNav?.Mobile) :
            (userDataTopNav.FirstName || userDataTopNav.LastName) ? userDataTopNav.FirstName + ' ' +
            userDataTopNav.LastName
            : userDataTopNav.Mobile
            }}</span>
        </button>

      </li>
    </ul>


  </nav>
</header>

<mat-menu #loginDropDown="matMenu" class="header-dropdown">
  <ng-template matMenuContent>
    <a mat-menu-item href="/persian/userprofile/#/dashboard" id="link-profile" rel="nofollow"
      class="text-sm !font-semi-bold">ویرایش
      پروفایل</a>
    <a mat-menu-item href="/persian/userprofile/#/reserve" id="link-userprofile-reserve" rel="nofollow"
      class="text-sm !font-semi-bold">رزرو های
      من</a>
    <a rel="nofollow" href="/" (click)="logOut($event)" id="btn-logout"
      class="mx-auto mt-1 w-5/6 rounded-md flex items-center justify-center py-2 px-3 border border-solid border-grey-100 transition-colors hover:bg-grey-50"
      mat-flat-button color="primary">خروج از حساب کاربری</a>
  </ng-template>
</mat-menu>

<mat-menu MatMenuTrigger #hotels="matMenu" class="header-dropdown mt-6">
  <ng-template matMenuContent>
    <div (mouseleave)="closeHotelMenu()">
      <a mat-menu-item href="/mashhad-hotels/" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
        هتل‌ های مشهد
      </a>
      <a mat-menu-item href="/tehran-hotels/" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
        هتل‌ های تهران
      </a>
      <a mat-menu-item href="/shiraz-hotels/" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
        هتل‌ های شیراز
      </a>
      <a mat-menu-item href="/isfahan-hotels/" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
        هتل‌ های اصفهان
      </a>
      <a mat-menu-item href="/kish-hotels/" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
        هتل‌ های کیش
      </a>
      <a mat-menu-item href="/iran-hotels/" target="_blank"
        class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
        هتل‌ های ایران
      </a>
      <a mat-menu-item href="/international-hotels/" target="_blank"
        class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
        هتل‌ های خارجی
      </a>

    </div>
  </ng-template>
</mat-menu>

<mat-menu MatMenuTrigger #ecolodgeMenu="matMenu" class="header-dropdown mt-6">
  <ng-template matMenuContent>
    <div (mouseleave)="closeEcolodgeMenu()">
      <a mat-menu-item href="/ecolodge/مشهد/" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">ویلاهای
        مشهد</a>
    </div>
  </ng-template>
</mat-menu>

<ng-container *ngIf="showCardWithData && navigatorVall">
  <iho-last-reserve-card *ngIf="!showCardReserve" (emitClose)="emitClose($event)" [isMobile]="navigatorVall"
    [latestActiveReserve]="latestActiveReserve"></iho-last-reserve-card>
</ng-container>
